<!--
  ~ Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
  ~ Spin in het Web B.V. Apeldoorn.
  ~ Deze software mag alleen gebruikt / bekeken / gewijzigd worden
  ~ volgens de voorwaarden die zijn vastgelegd in de overeenkomst
  ~ tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
  ~ overeenkomsten tussen Slimme Infrasoftware B.V en
  ~ Spin in het Web B.V.
  -->

<div class="regel-acties d-flex align-items-center ml-2 mb-1">
  <!-- Alleen tonen als de regel niet in de rootgroep zit -->
  @if (!isInRootGroep) {
    <button class="btn btn-outline-secondary btn-sm mr-1"
            title="Verplaats deze regel naar de bovenliggende groep"
            (click)="klikUitDezeGroep()">
      <span class="fas fa-level-up-alt"></span>
    </button>
  }

  <button class="btn btn-outline-info btn-sm mr-1"
          title="Plaats een EN-groep om deze regel"
          (click)="klikWikkelEn()">
    <span class="fas fa-layer-group"></span>
  </button>

  <button class="btn btn-outline-info btn-sm mr-1"
          title="Plaats een OF-groep om deze regel"
          (click)="klikWikkelOf()">
    <span class="fas fa-code-branch"></span>
  </button>

  <button class="btn btn-outline-danger btn-sm"
          title="Verwijder deze regel"
          (click)="klikVerwijder()">
    <span class="fas fa-trash"></span>
  </button>
</div>
